export default __webpack_public_path__ + "static/media/roundDownload.0388f7ee.svg";